import { inspect } from 'util'

import { Logger } from 'twilio-video'

import { isDevelopment } from 'helpers/miscellaneous'

import { logger } from './logger'

const shouldLog = ['BETA', 'STAGING', 'DEVELOPMENT'].includes(
    process.env.REACT_APP_CUSTOM_NODE_ENV
)

const twilioLogger = Logger.getLogger('twilio-video')
const originalFactory = twilioLogger.methodFactory
const twilioLogLevels = Logger.levels

twilioLogger.methodFactory = (methodName, level, loggerName) => {
    const method = originalFactory(methodName, level, loggerName)

    return (datetime, logLevel, component, message, data = '') => {
        shouldLog && method(datetime, logLevel, component, message, data)
        logger.info(`[twilio] ${component} ${message} ${inspect(data)}`)
    }
}

export const useTwilioLogger = () => {
    // you need to setLevel to info (or debug) in order to intercept signaling events.
    const level = isDevelopment ? twilioLogLevels.SILENT : twilioLogLevels.INFO
    twilioLogger.setLevel(level)
}

export default Logger
